
























































import { DailySessionData } from '@empathybroker/tsclient-stats/dist/models/daily-session/daily-session-data';
import { DailySessionResponse } from '@empathybroker/tsclient-stats/dist/models/daily-session/daily-session.response';
import { DailyPivotDistributionPoint } from '@empathybroker/tsclient-stats/dist/models/distributionreport/dailypivot/data/dailypivotdistribution-point';

import { ResizeObserver as ResizeObserverPolyfill } from '@juggle/resize-observer';

import { mapGetters } from 'vuex';

import { CompareFilterEnum, FilterIdEnum, KpiEnum, OrientationEnum } from '../../enums';

import { Dictionary, PeriodsData, RegularFilter } from '../../models';

import { ANALYTICS_CONSTS } from '../../store/analytics/analytics.consts';
import { CONFIG_CONSTS } from '../../store/config/config.consts';
import { CONTEXT_CONSTS } from '../../store/context/context.consts';

import KpiExpander from './kpi-expander.component.vue';
import KpiNotAvailable from './kpi-not-available.component.vue';
import KpiSummary from './kpi-summary.component.vue';

export enum AnimationStepsIndexEnum {
  EXPANDER = 0,
  KPIS = 1
}

export enum KpisRowIdEnum {
  TOP = 'top',
  BOTTOM = 'bottom'
}

export default {
  name: 'funnel-chart',
  components: {
    KpiNotAvailable,
    KpiExpander,
    KpiSummary
  },
  props: {
    selectedId: String,
    animationStepDurationsInMillis: Array,
    currentAnimationStep: Number
  },
  computed: {
    ...mapGetters(CONFIG_CONSTS.moduleName, {
      kpis: CONFIG_CONSTS.getters.kpis
    }),
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      filters: CONTEXT_CONSTS.getters.enabledFilters
    }),
    ...mapGetters(ANALYTICS_CONSTS.moduleName, {
      data: ANALYTICS_CONSTS.getters.data
    }),
    funnelChartData: function (): Dictionary<number[]> {
      const chartData = Object.values(KpiEnum).reduce((processedData: Dictionary<number[]>, kpi: KpiEnum) => {
        processedData[kpi] = [];
        return processedData;
      }, {});
      const data = { dist: undefined, sessions: undefined };
      if (!this.selectedId) {
        data.dist = this.data.overall.dist;
        data.sessions = this.data.overall.sessions;
      } else {
        const selectedIdData = this.data.ids[this.selectedId];
        if (!!selectedIdData) {
          data.dist = selectedIdData.dist;
        }
      }
      this.kpis.forEach((kpi: KpiEnum) => {
        const kpiData = this.getKpiData(kpi, data);
        if (!!kpiData) {
          chartData[kpi].push(kpiData);
        }
        if (!!this.compareFilterValue) {
          const compareKpiData = this.getKpiData(kpi, data, this.compareFilterValue);
          if (!!compareKpiData) {
            chartData[kpi].push(compareKpiData);
          }
        }
      });
      return chartData;
    },
    compareFilterValue: function (): CompareFilterEnum {
      const compareFilter: RegularFilter = this.filters[FilterIdEnum.COMPARE];
      if (!!compareFilter) {
        return (compareFilter.selectedValues[0] as CompareFilterEnum);
      }
    },
    rowIds: function (): string[] {
      return Object.keys(this.kpisPerRow);
    },
    kpisPerRowDisplayed: function () {
      return this.rowIds.reduce((kpisPerRowDisplayed, rowId) => {
        kpisPerRowDisplayed[rowId] = this.kpisPerRow[rowId]
          .filter((kpi: KpiEnum, index: number) => this.lastKpiIndexDisplayed >= index);
        return kpisPerRowDisplayed;
      }, {});
    },
    maxKpisPerRow: function (): number {
      return Math.max(...Object.values(this.kpisPerRow).map((rowKpis: KpiEnum[]) => rowKpis.length));
    },
    kpiWidth: function (): number {
      const kpiSummaryWidthPercentage = this.kpiSummary.widthPercentage / 100;
      return ((this.funnelContainerWidth - (this.expander.width / 2)) / (this.maxKpisPerRow + (kpiSummaryWidthPercentage / 2)));
    },
    kpiTransitionDurationInMillis: function (): number {
      return (this.animationStepDurationsInMillis[AnimationStepsIndexEnum.KPIS] / this.maxKpisPerRow);
    },
    kpiTransitionWidthDurationInMillis: function (): number {
      return (this.kpiTransitionDurationInMillis / 5 * 3);
    },
    kpisRowStyles: function () {
      const styles: any = {};
      const kpiSummaryWidth = this.kpiWidth * (this.kpiSummary.widthPercentage / 100);
      styles.marginRight = `${ kpiSummaryWidth / 2 }px`;

      return styles;
    },
    funnelContentWrapperStyles: function () {
      const styles: any = {
        height: `${ this.funnelHeight.initial }px`,
        transitionProperty: 'height',
        transitionDuration: `${ this.animationStepDurationsInMillis[AnimationStepsIndexEnum.EXPANDER] }ms`,
        transitionDelay: `${ this.expander.transitionDurationInMillis }ms`
      };

      if (this.kpiExpanderExpanded) {
        styles.height = `${ this.funnelHeight.expanded }px`;
      }

      return styles;
    },
    groupBackgroundStyles: function () {
      const styles: any = {};
      const kpiSummaryWidth = this.kpiWidth * (this.kpiSummary.widthPercentage / 100);
      const backgroundPaddingInPixels = 5;
      styles.left = `${ -kpiSummaryWidth / 2 - backgroundPaddingInPixels }px`;
      styles.bottom = `${ this.expander.height / 2 + this.path.height }px`;
      styles.height = `${ kpiSummaryWidth / 2 + backgroundPaddingInPixels }px`;
      styles.width = `${ this.kpiWidth + kpiSummaryWidth + backgroundPaddingInPixels * 2 }px`;
      styles.borderTopLeftRadius = `${ kpiSummaryWidth / 2 + backgroundPaddingInPixels }px`;
      styles.borderTopRightRadius = `${ kpiSummaryWidth / 2 + backgroundPaddingInPixels }px`;
      styles.transitionDuration = `${ this.kpiTransitionWidthDurationInMillis }ms`;

      return styles;
    },
    kpiExpanderContainerStyles: function () {
      const styles: any = {
        transitionProperty: 'margin-left',
        transitionDuration: `${ this.animationStepDurationsInMillis[AnimationStepsIndexEnum.EXPANDER] }ms`,
        transitionDelay: `${ this.expander.transitionDurationInMillis }ms`
      };
      if (this.kpiExpanderExpanded) {
        styles.marginLeft = `${ -this.expander.width / 2 }px`;
      }
      return styles;
    },
    kpiExpanderStyles: function () {
      const styles: any = {
        width: `${ this.expander.width }px`,
        height: `${ this.expander.height }px`
      };

      if (this.kpiExpanderExpanded) {
        styles.transform = `translate3d(50%, 0, 0)`;
        styles.transtionProperty = 'transform';
        styles.transitionDuration = `${ this.animationStepDurationsInMillis[AnimationStepsIndexEnum.EXPANDER] }ms`;
        styles.transitionDelay = `${ this.expander.transitionDurationInMillis }ms`;
      }
      return styles;
    },
    kpiExpanderConfig: function () {
      return {
        id: KpiEnum.QUERIES,
        core: {
          label: this.getKpiLabel(KpiEnum.QUERIES),
          values: this.funnelChartData[KpiEnum.QUERIES]
        },
        asides: [
          {
            orientation: 'left',
            label: this.getKpiLabel(KpiEnum.SESSIONS),
            values: this.funnelChartData[KpiEnum.SESSIONS]
          },
          {
            orientation: 'right',
            label: this.getKpiLabel(KpiEnum.QUERIES_PER_SESSION),
            values: this.funnelChartData[KpiEnum.QUERIES_PER_SESSION]
          }
        ],
        expanded: this.kpiExpanderExpanded
      };
    }
  },
  data: function () {
    return {
      funnelHeight: {
        initial: 250,
        expanded: 510
      },
      expander: {
        width: 460,
        height: 130,
        transitionDurationInMillis: 500
      },
      kpiExpanderExpanded: false,
      kpisPerRow: {
        [KpisRowIdEnum.TOP]: [KpiEnum.CLICKS, KpiEnum.FINDABILITY, KpiEnum.ADD2CART, KpiEnum.CHECKOUT],
        [KpisRowIdEnum.BOTTOM]: [KpiEnum.NO_RESULTS]
      },
      lastKpiIndexDisplayed: 0,
      funnelContainerWidth: 0,
      kpiSummary: {
        widthPercentage: 50,
        core: {
          radius: 5,
          padding: 5
        }
      },
      path: {
        strokeWidth: 2,
        height: 35
      },
      resizeObserver: undefined,
      messages: this.$epb.messages.analytics,
      AnimationStepsIndexEnum,
      KpiEnum,
      KpisRowIdEnum,
      OrientationEnum
    };
  },
  methods: {
    getKpiData: function (kpi: KpiEnum, data: { dist?: PeriodsData, sessions?: PeriodsData<DailySessionResponse> },
      compareFilterValue?: CompareFilterEnum): number {
      let distData: DailyPivotDistributionPoint, sessionsData: DailySessionData;
      if (!!data.dist) {
        const periodDistData = (!!compareFilterValue ? data.dist[compareFilterValue] : data.dist.currentPeriod);
        distData = (periodDistData && periodDistData.data);
      }
      if (!!data.sessions) {
        const periodSessionsData = (!!compareFilterValue ? data.sessions[compareFilterValue] : data.sessions.currentPeriod);
        sessionsData = (periodSessionsData && periodSessionsData.data);
      }
      return {
        [KpiEnum.QUERIES]: () => (!!distData ? distData.queryCount : undefined),
        [KpiEnum.CLICKS]: () => (!!distData ? distData.clickCountPct : undefined),
        [KpiEnum.FINDABILITY]: () => (!!distData ? distData.findability : undefined),
        [KpiEnum.ADD2CART]: () => (!!distData ? distData.add2cartCountPct : undefined),
        [KpiEnum.CHECKOUT]: () => (!!distData ? distData.checkoutCountPct : undefined),
        [KpiEnum.NO_RESULTS]: () => (!!distData ? distData.noResultsCountPct : undefined),
        [KpiEnum.SESSIONS]: () => (!!sessionsData ? sessionsData.sessionCount : undefined),
        [KpiEnum.QUERIES_PER_SESSION]: () => (!!sessionsData ? sessionsData.queriesPerSession : undefined)
      }[kpi]();
    },
    getKpiLabel: function (kpi: KpiEnum): string {
      const kpisMessages = this.messages.kpis;
      return {
        [KpiEnum.QUERIES]: () => kpisMessages[KpiEnum.QUERIES].valueLabel,
        [KpiEnum.CLICKS]: () => kpisMessages[KpiEnum.CLICKS].percentageLabel,
        [KpiEnum.FINDABILITY]: () => kpisMessages[KpiEnum.FINDABILITY].percentageLabel,
        [KpiEnum.ADD2CART]: () => kpisMessages[KpiEnum.ADD2CART].percentageLabel,
        [KpiEnum.CHECKOUT]: () => kpisMessages[KpiEnum.CHECKOUT].percentageLabel,
        [KpiEnum.NO_RESULTS]: () => kpisMessages['noResults'].valueLabel,
        [KpiEnum.SESSIONS]: () => kpisMessages[KpiEnum.SESSIONS].valueLabel,
        [KpiEnum.QUERIES_PER_SESSION]: () => kpisMessages[KpiEnum.QUERIES_PER_SESSION].valueLabel
      }[kpi]();
    },
    onKpiExpanderEnter: function (): void {
      setTimeout(() => this.kpiExpanderExpanded = true,
        this.animationStepDurationsInMillis[this.currentAnimationStep] - this.expander.transitionDurationInMillis);
    },
    getKpiPath: function (kpiIndex: number, kpi: KpiEnum): string {
      const midStrokeWidth = (this.path.strokeWidth / 2);
      const midKpiSummaryCoreWidth = (this.kpiSummary.core.radius + this.kpiSummary.core.padding);
      const widthMinusKpiSummary = (this.kpiWidth - midKpiSummaryCoreWidth);
      const pathEnd = this.isKpiAvailable(kpi) ? widthMinusKpiSummary : this.kpiWidth / 2;
      return (kpiIndex === 0) ? `M ${ midStrokeWidth } ${ this.path.height -
        midStrokeWidth - 5 } Q ${ midStrokeWidth } 0 30 ${ midStrokeWidth } L ${ widthMinusKpiSummary } ${ midStrokeWidth }`
        : `M ${ midStrokeWidth + midKpiSummaryCoreWidth } ${ midStrokeWidth } L ${ pathEnd } ${ midStrokeWidth }`;
    },
    getKpiSummaryOrientation: function (rowId: KpisRowIdEnum): OrientationEnum {
      return {
        [KpisRowIdEnum.TOP]: () => OrientationEnum.TOP,
        [KpisRowIdEnum.BOTTOM]: () => OrientationEnum.BOTTOM
      }[rowId]();
    },
    getKpiStyles: function (rowId: KpisRowIdEnum, kpi: KpiEnum) {
      const kpiIndex = this.kpisPerRow[rowId].indexOf(kpi);
      const styles: any = {
        transitionDuration: `${ this.kpiTransitionWidthDurationInMillis }ms`
      };
      if (this.lastKpiIndexDisplayed > kpiIndex) {
        styles.width = `${ this.kpiWidth }px`;
      }
      styles[(rowId === KpisRowIdEnum.TOP) ? 'padding-bottom' : 'padding-top'] = `${ (this.expander.height / 2) }px`;

      return styles;
    },
    getKpiInfoStyles: function (rowId: KpisRowIdEnum, kpi: KpiEnum, kpiIndex: number) {
      const styles: any = {
        width: `${ this.kpiSummary.widthPercentage }%`,
        right: `${ -this.kpiSummary.widthPercentage / 2 }%`,
        animationDuration: `${ this.kpiTransitionDurationInMillis - this.kpiTransitionWidthDurationInMillis }ms`,
        animationDelay: `${ this.kpiTransitionDurationInMillis - this.kpiTransitionWidthDurationInMillis }ms`
      };

      if (this.isKpiAvailable(kpi)) {
        styles[(rowId === KpisRowIdEnum.TOP) ? 'bottom' : 'top'] = `${ this.expander.height / 2 + this.path.height }px`;
      } else {
        styles.width = `${ this.kpiSummary.widthPercentage * 1.5 }%`;
        if (!this.isLastKpiOfRow(kpiIndex)) {
          styles.right =
            `calc(${ -((this.kpiSummary.widthPercentage * 1.5) - this.kpiSummary.widthPercentage) }% + ${ (this.kpiSummary.core.padding +
              this.kpiSummary.core.radius) * 2 }px)`;
        }
      }

      return styles;
    },
    isKpiAvailable: function (kpi: KpiEnum): boolean {
      return this.kpis.includes(kpi);
    },
    isLastKpiOfRow: function (kpiIndex): boolean {
      return (kpiIndex === (this.maxKpisPerRow - 1));
    },
    isGroupedKpi: function (kpi: KpiEnum, index: number, rowId: KpisRowIdEnum): boolean {
      const lastKpi: KpiEnum = this.kpisPerRow[rowId][index - 1];
      return (!!lastKpi && (kpi === KpiEnum.FINDABILITY) && (lastKpi === KpiEnum.CLICKS));
    }
  },
  mounted: function (): void {
    const ResizeObserver = (window['ResizeObserver'] || ResizeObserverPolyfill);
    this.resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const { width } = entry.contentRect;
        this.funnelContainerWidth = width;
      });
    });
    this.resizeObserver.observe(this.$refs.funnelContainer);
  },
  beforeDestroy: function (): void {
    this.resizeObserver.disconnect();
  }
};
